<mat-nav-list [class.isMobile]="isMobile">
    <span *ngIf="isMobile">
        <mat-list-item class="pm-title" *ngxPermissionsOnly="['viewPMSideNav']">
            <h2>Property Management</h2>
        </mat-list-item>
    </span>
    <mat-list-item routerLinkActive="active" *ngxPermissionsExcept="['viewCustomerPortal']">
        <a mat-icon-button routerLink="/dashboard">
            <mat-icon svgIcon="cc-dashboard"></mat-icon>
            <span class="nav-caption">Home</span>
        </a>
    </mat-list-item>
    <mat-list-item routerLinkActive="active" *ngxPermissionsOnly="['viewProject', 'editProject']">
        <a mat-icon-button routerLink="/accounts">
            <mat-icon svgIcon="cc-projects"></mat-icon>
            <span class="nav-caption">Accounts</span>
        </a>
    </mat-list-item>
    <mat-list-item routerLinkActive="active" *ngxPermissionsOnly="['viewCustomerList']">
        <a mat-icon-button routerLink="/customers">
            <mat-icon svgIcon="cc-staff"></mat-icon>
            <span class="nav-caption">Customers</span>
        </a>
    </mat-list-item>
    <mat-list-item routerLinkActive="active" *ngxPermissionsOnly="['viewCompany', 'editCompany', 'editCompanySettings', 'updateLockoutScreen']">
        <a mat-icon-button routerLink="/entities">
            <mat-icon svgIcon="cc-dealers"></mat-icon>
            <span class="nav-caption">Companies</span>
        </a>
    </mat-list-item>
    <mat-list-item routerLinkActive="active" *ngxPermissionsOnly="['editAllCustomers']">
        <a mat-icon-button routerLink="/all-staff">
            <mat-icon svgIcon="cc-dealers"></mat-icon>
            <span class="nav-caption">All Staff</span>
        </a>
    </mat-list-item>
    <mat-list-item routerLinkActive="active" *ngxPermissionsExcept="['viewCustomerPortal', 'viewPMSideNav']">
        <a
            mat-icon-button
            href="https://www.clarecontrols.com/helpcenter/fusionpro-user-guide-doc-id-1918"
            rel="noopener noreferrer"
            target="_blank"
        >
            <mat-icon svgIcon="cc-help"></mat-icon>
            <span class="nav-caption">Help Center</span>
        </a>
    </mat-list-item>
    <mat-list-item routerLinkActive="active" *ngxPermissionsOnly="['viewPMSideNav']">
        <a
            mat-icon-button
            href="https://www.clarecontrols.com/helpcenter/mdu-property-management"
            rel="noopener noreferrer"
            target="_blank"
        >
            <mat-icon svgIcon="cc-help"></mat-icon>
            <span class="nav-caption">Help Center</span>
        </a>
    </mat-list-item>
    <mat-list-item routerLinkActive="active" *ngxPermissionsOnly="['viewWhatsNew']">
        <a mat-icon-button href="https://www.clarecontrols.com/en/helpcenter/whats-new" rel="noopener noreferrer" target="_blank">
            <mat-icon svgIcon="cc-new"></mat-icon>
            <span class="nav-caption">What's New</span>
        </a>
    </mat-list-item>
</mat-nav-list>
<div class="userinfo" *ngIf="user">
    <p>Signed in as:</p>
    <p>{{ user.email }}</p>
    <p class="logout" (click)="logout()">Sign out</p>
</div>
